/**
 * Scroll button — scrolls to the section after the one containing the button.
 * Goes through Lenis when it is running so the two do not fight over the
 * scroll position; falls back to native smooth scrolling when it is not
 * (reduced motion, or if Lenis failed to start).
 */

import { getLenis } from './smooth-scroll';

export default function scrollButtons() {
  document.querySelectorAll<HTMLButtonElement>('.scroll-button').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('.blocks > *, .site-content > *');
      const target = section?.nextElementSibling;
      if (!target) return;

      const lenis = getLenis();
      if (lenis) lenis.scrollTo(target as HTMLElement);
      else target.scrollIntoView({ behavior: 'smooth' });
    });
  });
}
